var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.155.996H.869a.797.797 0 00-.606.295c-.161.19-.251.446-.251.714v8.074c0 .267.09.524.25.713.162.19.38.296.607.296h10.286a.798.798 0 00.606-.296c.16-.189.25-.446.25-.713V2.005c0-.268-.09-.525-.25-.714a.798.798 0 00-.606-.295zm-.943 1.009l-4.2 3.421-4.2-3.421h8.4zM.869 10.079V2.464l4.898 3.992c.072.058.157.09.245.09a.385.385 0 00.244-.09l4.899-3.992v7.615H.869z"
  })));
}
export default SvgEmailIcon;